import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum ContactStatusIds {
  PENDING = 1,
  ACTIVE = 2,
  ON_HOLD = 3,
  RETIRED = 4,
}

export function getContactStatii(): ISelectItem[] {
  return [
    { id: ContactStatusIds.PENDING, label: 'Pending' },
    { id: ContactStatusIds.ACTIVE, label: 'Active' },
    { id: ContactStatusIds.ON_HOLD, label: 'On Hold' },
    { id: ContactStatusIds.RETIRED, label: 'Retired' },
  ]
}

export const getContactStatusByLabel = getItemByLabelFactory(getContactStatii)
export const getContactStatusById = getItemByIdFactory(getContactStatii)
